import React from "react";
import {CityFrom} from "./components/fields/CityFrom";
import {CityReplacer} from "./components/fields/CityReplacer";
import {CityTo} from "./components/fields/CityTo";
import {DepartureDate} from "./components/fields/DepartureDate";
import {CargoName} from "./components/fields/CargoName";
import {SizeType} from "./components/SizeType";
import {GetTickets} from "./components/GetTickets";
import {Tickets} from "./components/Tickets";
import {useSelector} from "react-redux";
import {PopupMobile} from "./components/PopupMobile";

export const MobileApp = () => {
    const popup = useSelector(state => state.app.popup)
    if (!popup) {
        return (
            <React.Fragment>
                <section className="front-calc container" id="front-calc">
                    <div className="container__wrap">
                        <div className="front-calc__flex">
                            <div className="front-calc__path">
                                <div className="front-calc__from">
                                    <CityFrom/>
                                </div>
                                <div className="front-calc__city_replace">
                                    <CityReplacer/>
                                </div>
                                <div className="front-calc__to">
                                    <CityTo/>
                                </div>
                            </div>
                            <div className="front-calc__params">
                                <div className="front-calc__departure_date">
                                    <DepartureDate/>
                                </div>
                                <div className="front-calc__cargo_type">
                                    <CargoName/>
                                </div>
                            </div>
                        </div>
                        <SizeType/>
                        <GetTickets/>
                    </div>
                </section>
                <Tickets/>
            </React.Fragment>
        );
    } else{
        return (
            <React.Fragment>
                <PopupMobile/>
            </React.Fragment>
        );
    }
}